<template>
  <div class="banner-slider-warpper">
    <tiny-slider
      :controlsText="controlsText"
      :mouse-drag="true"
      :loop="false"
      :items="slides"
      gutter="20"
      v-if="liveCourses.length > 0"
    >
      <div v-for="i in 3" :key="i">
        <course-banner
          :liveCourse="liveCourses[i - 1]"
          @playLiveVideo="playLiveVideo"
        />
      </div>
    </tiny-slider>
    <video-modal :video-url="videoUrl" :show-play-list="showPlayList" />
  </div>
</template>

<script>
import CourseBanner from "../Templates/CourseBanner";
import videoModal from "../modals/VideoModal";
import { store } from "../../store/store";
import { mapGetters } from "vuex";

export default {
  components: {
    CourseBanner,
    videoModal
  },
  data() {
    return {
      showPlayList: false,
      videoUrl: "",
      liveCourseId: "",
      liveCourseRoom: ""
    };
  },
  props: {
    slides: Number,
    liveCourses: Array
  },
  computed: {
    ...mapGetters("user", [
      "isAuthenticated",
      "getUserRole",
      "getUserDetails",
      "getSubscribedLiveCourses",
      "getTeacherLiveCourses"
    ]),
    ...mapGetters("events", ["getShowLiveVideo"]),
    controlsText() {
      const arrows = [];
      arrows.push(
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaCAYAAACHD21cAAAACXBIWXMAAAsTAAALEwEAmpwYAAAF62lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDIgNzkuMTYwOTI0LCAyMDE3LzA3LzEzLTAxOjA2OjM5ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdEV2dD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlRXZlbnQjIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnBob3Rvc2hvcD0iaHR0cDovL25zLmFkb2JlLmNvbS9waG90b3Nob3AvMS4wLyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiB4bXA6Q3JlYXRlRGF0ZT0iMjAxOS0wNi0wNVQxMDo0OTowMyswNTozMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAxOS0wNi0wNVQxMDo0OTowMyswNTozMCIgeG1wOk1vZGlmeURhdGU9IjIwMTktMDYtMDVUMTA6NDk6MDMrMDU6MzAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Zjg5MzRhOWYtMTlkYi04NjQxLWE0ODYtYzM2Mjk0NDUxNDFlIiB4bXBNTTpEb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YzJkZTQ0ZmYtN2U3Mi0wYjQwLWE2NzgtNjVhODVlMjc1OTViIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6NjAwZGEzYjAtMTcyYi00MzRjLWIwNWMtMjZjYWU4NTlhN2JhIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIgcGhvdG9zaG9wOklDQ1Byb2ZpbGU9InNSR0IgSUVDNjE5NjYtMi4xIj4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MDBkYTNiMC0xNzJiLTQzNGMtYjA1Yy0yNmNhZTg1OWE3YmEiIHN0RXZ0OndoZW49IjIwMTktMDYtMDVUMTA6NDk6MDMrMDU6MzAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAoV2luZG93cykiLz4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOmY4OTM0YTlmLTE5ZGItODY0MS1hNDg2LWMzNjI5NDQ1MTQxZSIgc3RFdnQ6d2hlbj0iMjAxOS0wNi0wNVQxMDo0OTowMyswNTozMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7fyQi4AAAAzElEQVQ4EZ3B3SqDcRwA4CdTNiduQSnLAV4ntGFX4Q6U07WVj9tx6kDkwMF8XI2EFC8t2erHJfx/ex7/DnBkBucInEpawg0CA0nzuEZgKGkRDwicSFrALQIDSQ1cIdCX1MI9AmeSmrhDYCCpgUsE+pKaGCFwLKmFRwSGZjBC4HBOuWW0McWTQmt4Q40dhSqMMUZHoXW8I9BTqI1X/KCjUIVvfKGrUIUPBPYVWsULfrGr0CZqfKKj0BZqBPYU2sYzJuhJuMAEXUkr2JD0BxSyNkiiUs/ZAAAAAElFTkSuQmCC">'
      );
      arrows.push(
        '<img src="data:image/png;base64,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">'
      );
      return arrows;
    }
  },
  methods: {
    playLiveVideo(room_number, courseId) {
      if (this.isAuthenticated && this.getUserRole === "teacher") {
        if (
          this.getTeacherLiveCourses.length > 0 &&
          this.getTeacherLiveCourses.some(
            courseD => courseD.course_id === courseId
          )
        ) {
          this.$router.push({
            path: "/live_start",
            query: {
              room_number: room_number,
              course_id: courseId
            }
          });
        } else if (
          this.getSubscribedLiveCourses.length > 0 &&
          this.getSubscribedLiveCourses.some(
            courseD => courseD.course_id === courseId
          )
        ) {
          this.videoUrl = `https://studiov2.lyceum.one/webrtc/?room=${room_number}`;
          this.$bvModal.show("video-modal");
        } else {
          store.dispatch("courses/setLiveCourse", true);
          this.$router.push({
            path: "/course_description",
            query: { courseId: courseId, courseType: "liveCourse" }
          });
        }
      } else if (
        this.isAuthenticated &&
        this.getUserRole === "student" &&
        this.getUserDetails.studentLiveCourses
      ) {
        if (
          this.getSubscribedLiveCourses.length > 0 &&
          this.getSubscribedLiveCourses.some(
            courseD => courseD.course_id === courseId
          )
        ) {
          this.videoUrl = `https://studiov2.lyceum.one/webrtc/?room=${room_number}`;
          this.$bvModal.show("video-modal");
        } else {
          store.dispatch("courses/setLiveCourse", true);
          this.$router.push({
            path: "/course_description",
            query: { courseId: courseId, courseType: "liveCourse" }
          });
        }
      } else {
        store.dispatch("courses/setLiveCourse", true);
        this.$router.push({
          path: "/course_description",
          query: { courseId: courseId, courseType: "liveCourse" }
        });
      }
    }
  },
  watch: {
    getShowLiveVideo() {
      store.dispatch("events/setShowLiveVideo", false);
      this.playLiveVideo(this.liveCourseRoom, this.liveCourseId);
    }
  },
  mounted() {
    console.log(typeof this.liveCourses);
  }
};
</script>

<style></style>
